
import React from 'react';
import EmailTemplateTable from '@/components/email/EmailTemplateTable';
import EmailTemplateForm from '@/components/email/EmailTemplateForm';
import QuestionManagementMenu from '@/components/admin/QuestionManagementMenu';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

const AdminEmailTemplates = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex flex-col">
      <Header />
      <div className="flex-1 container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Email Templates</h1>
        <QuestionManagementMenu />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <EmailTemplateForm />
          <EmailTemplateTable />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminEmailTemplates;
